import { createPinia } from 'pinia';

// Create and export the pinia instance
const pinia = createPinia();

export { pinia };
